var tendersList = angular.module('tendersList', [
    'commons.app',
    'ui.bootstrap.modal',
    'ui.router'
]);